interface InputProps {
    type: string
    value: string | number
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    name?: string
    placeholder?: string
    maxLength?: number
    disabled?: boolean
    className?: string
    onCopy?: (event: React.ClipboardEvent<HTMLInputElement>) => void
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

export default function Input({ type, value, onChange, name, placeholder, maxLength, disabled, className, onCopy, onKeyPress }: InputProps) {
    return <input 
        className={`w-full p-2 border border-gray-300 rounded-md text-gray-800 text-sm outline-none disabled:bg-gray-200 disabled:cursor-not-allowed disabled:text-gray-400 ${className}`}
        type={type}
        value={value}
        onChange={onChange}
        name={name}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        onCopy={onCopy}
        onKeyPress={onKeyPress}
    />;
}